<template>
  <div class="live-statics">
    <div class="sta_area">
      <Head @selectLiveRomm="selectLiveRomm" @refresh="refreshPage"/>
      <Top
         v-if="canFetchStat" 
        :overallStatis="overallStatis" 
        :miguStatistics="miguStatistics" />
      <div v-else class="empty">
        <el-empty description="暂无数据，请选择直播"></el-empty>
      </div>
    </div>
    <div v-if="canFetchStat">
      <el-row :gutter="16" >
        <el-col  :md="24" :lg="12">
          <Section  title="观看时长人数分析" showTips>
              <Pie pieId="pie1" :data="watchTimeStatPie" />
          </Section>
        </el-col>
        <el-col :md="24" :lg="12" >
          <Section title="观看终端分析">
            <Pie pieId="pie2" :data="deviceStatPie"/>
          </Section>
        </el-col>
      </el-row>
      <el-row :gutter="16" >
        <el-col :md="24" :lg="12" >
          <Section  title="观看用户管理主体分布">
            <Pie pieId="pie3" :data="leaderTypeStatPie"/>
          </Section>
        </el-col>
        <el-col :md="24" :lg="12">
          <Section title="观看用户学院分布">
            <Pie pieId="pie4" :data="academyStatPie"/>
          </Section>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"  class="mb-24">
          <Section title="直播间观看并发情况" showTips>
            <el-form class="form" size="small" label-width="80px">
              <el-form-item label="查询周期：">
                <div class="date-content">
                  <DatePicker :dateValue="queryDate" @dateChange="dateChange" />
                  <butn class="ml-16" btntype="primary" title="查询" @click.native="search"></butn>
                </div>
                <div class="date-content">
                  <i class="el-icon-warning mr-6 "></i>
                  跨度最大不可超过48小时
                </div>
              </el-form-item>
            </el-form>
            <LineChart :data="watchConcurrency" />
          </Section>  
        </el-col>
      </el-row>
    </div>
    
  </div>
</template>
<script>
import butn from "@/components/button/index";
import { 
  Head, 
  Top, 
  Section, 
  Pie, 
  LineChart,
  DatePicker } from "./components"
import {
  overallStatistics,
  miguStatistics,
} from "@/api/resourceService"
import {
  getWatchTimeStatistics,
  getLiveDeviceStatistics,
  getLeaderTypeStatistics,
  getAcademyStatistics,
  getHistoryOnlineNum
} from "./api"

export default {
  name: "liveStatistics",
  components: {
    Head, Top, Section, Pie, LineChart, DatePicker, butn
  },
  data() {
    return {
      watchTimeStatPie: null,
      deviceStatPie: null,
      leaderTypeStatPie: null,
      academyStatPie: null,
      // 观看并发
      watchConcurrency: [],


      overallStatis: {},
      miguStatistics: {},
      
      liveRoomId: null,
      queryDate: null,

    };
  },
  created() {
  },
  activated() {},
  computed: {
    canFetchStat() {
      return this.liveRoomId && this.liveRoomId.length > 0
    },
  },
  methods: {
    /**
     * 选择直播 刷新统计数据
     */
    refreshPage() {
      this.fetchTop();
      this.fetchCenter();
      this.fetchBottom();
    },

    selectLiveRomm(item) {
      this.liveRoomId = item.liveRoomId;
      this.liveStartTime = item.startTime;
      this.queryDate = null;
      if (this.canFetchStat) {
        this.refreshPage();
      }
    },

    /**
     * 顶部两行数据
     */
    fetchTop() {
      overallStatistics(this.liveRoomId).then(res => {
        if (res && res.code == 0) {
          this.overallStatis = res.data || {};
        }
      })
      miguStatistics(this.liveRoomId).then(res => {
        if (res && res.code == 0) {
          this.miguStatistics = res.data || {};
        }
      })
    },
    /**
     * 中间4个饼图数据请求
     */
    fetchCenter() {
      getWatchTimeStatistics(this.liveRoomId).then (res => {
        this.watchTimeStatPie = res;
      })
      getLiveDeviceStatistics(this.liveRoomId).then (res => {
        this.deviceStatPie = res;
      })
      getLeaderTypeStatistics(this.liveRoomId).then (res => {
        this.leaderTypeStatPie = res;
      })
      getAcademyStatistics(this.liveRoomId).then (res => {
        this.academyStatPie = res;
      })
    },
    /**
     * 底部折线图数据
     */
    fetchBottom() {
      let params = {
        uuid: this.liveRoomId
      }
      if (this.queryDate) {
        params.startTime = this.queryDate[0]
        params.endTime = this.queryDate[1]
      }
      getHistoryOnlineNum(params).then(res => {
        this.watchConcurrency = res;
      })
    },

    search () {
      this.fetchBottom();
    },

    dateChange(time) {
      this.queryDate = time;
    }

  },
};
</script>
<style lang="scss" scoped>

.live-statics {
  height: 100%;
  background-color: #F0F1F5;
  padding: 0 24px;
  overflow-y: scroll;
  flex: 1;
}
.live-statics::-webkit-scrollbar {
  display: none;
}
.sta_area {
  background: #FFFFFF;
  border-radius: 8px;
  margin-top: 24px;
  padding: 24px;
  margin-bottom: 16px;
}

.mb-24 {
  margin-bottom: 24px;
}

.ml-16 {
  margin-left: 16px;
}

.mr-6 {
  margin-right: 6px;
}

.empty {
  height: 100%;
}
.form {
  margin-top: 24px;
  .date-content {
    display: flex;
    align-items: center;
    color: #A9A9AA;
  }

}


</style>
